export default "__VITE_ASSET__D7Ex7gSw__"